import React, { Component } from 'react'
import { Link } from 'react-router'

import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import DatePicker from 'material-ui/DatePicker';


import AttachmentRender from './AttachmentRender'
import {blobToBase64} from 'utils/stuff'

export default (o) => {
	 let total = o.tasks?o.tasks.reduce((a, b) => a + (b.amount || 0), 0):0
     return(
        <div>
            <List>
                {o.tasks.map((task, index) => { console.log('task:', task)
				return(
                    <ListItem
						key={index + new Date()}//because uncontrolled TEXTFIELD has own state, it cant be reused
                        style={{overflow: "hidden", cursor: "default"}}
						onClick={(e)=> {
							if (task.readOnly && o.edit){
								e.currentTarget.getElementsByTagName('input')[1].focus()
							}
						}}
                    >
						{!task.readOnly && o.edit &&
							<span
								onClick={(e)=> {o.onItemDelete(index)}}
								style={{
									  float: "right"
									, cursor: "pointer"
								}}
							>
								❌
							</span>
						}
                        <div>
                            <TextField hintText="Enter task"
								disabled={task.readOnly || !o.edit}
								defaultValue={task.name || task.taskContent}
								style={{clear: "both", float: "left", width:"65%", cursor: (task.readOnly || !o.edit)?"default":"text"}}
								inputStyle={{color: "black"}}
								onBlur={(e) => {
									o.onItemChange({ index, change: { name: e.target.value } })
								}}
							/>
                            <div
                            style={{
                                  float: "right"
                                , position: "relative"
                                , top: "15px"
                                , width:"30%"
                                , overflow: "hidden"
                            }}>
								<TextField
                                    style={{
                                          float: "right"
                                        , width:"70%"
                                        , height: "50px"
                                        , marginTop: "-15px"
                                        , marginLeft: "2px"
										, cursor: (!o.edit)?"default":"text"
                                    }}
									inputStyle={{color: "black"}}
									defaultValue={task.amount || 0}
									disabled={!o.edit}
									min="0"
                                    type="Number"
                                    hintText="0"
									onBlur={(e) => {
										if (0 > +e.target.value) e.target.value = -e.target.value
										o.onItemChange({ index, change: { amount: + e.target.value } })
									}}
									onKeyDown={(evt) => {
							            if(evt.key == '-') return false
							        }}
                                />
                                <span style={{lineHeight: "21px", float: "right"}}>$</span>
                            </div>
                          <TextField
							  disabled={task.readOnly || !o.edit}
							  hintText={task.readOnly || !o.edit? "No task description" : "Enter task description"}
							  defaultValue={task.notes || task.description || ""}
							  style={{ clear: "both", width: "100%", marginBottom: "20px", cursor: (task.readOnly || !o.edit)?"default":"text"}}
							  inputStyle={{color: "black"}}
							  onBlur={(e) => {
								  o.onItemChange({ index, change: { description: e.target.value } })
							  }}
						  />
                      </div>
                  </ListItem>
			  )})}
            </List>

          <div
              style={{
                margin: "20px auto"
              , textAlign: "center"
              }}
          >
			  { o.edit &&
	              <RaisedButton
	                  label="ADD ITEM"
	                  style={{
	                        margin: "0px auto"
	                      , float: "left"
	                  }}
	                  onClick={o.onItemAdd}
	              />
			  }
			  <span style={{marginTop: "20px",float:"right"}}>Total: ${total}</span>
			  <div style={{clear: "both"}}></div>
          </div>

    </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/TaskList.js